module.exports = __webpack_public_path__ + "static/media/create-new-list.17eb0b10.png";